import Hero from '../components/Hero';
import WhatIs from '../components/WhatIs';
import HowItWorks from '../components/HowItWorks';
import Features from '../components/Features';
import Exchange from '../components/Exchange';
import Trust from '../components/Trust';
import CTA from '../components/CTA';

export default function HomePage() {
  return (
    <main>
      <Hero />
      <WhatIs />
      <HowItWorks />
      <Features />
      <Exchange />
      <Trust />
      <CTA />
    </main>
  );
}
